export const UnleashToggles = Object.freeze({
  HUBSPOT_INTEGRATION: 'hubspot-integration',
  MFE_PAYMENT_PAGE: 'payments_service',
  MFE_INSIGHTS_PAGE: 'mfe-insights-page',
  SURCHARGE_TAX_EXCISE_TAX: 'surcharge-tax-excise-tax',
  SURCHARGE_TAX_TERRITORY_TAX: 'surcharge-tax-territory-Tax',
  REGION_CONSUMER_TYPE: 'region-consumer-type',
  APPLY_REWARD: 'RewardsinApp',
  TRIP_SHARE_INVENTORIES: 'trip-share-inventories',
  PRODUCT_DESCRIPTION_RECEIPT: 'product-description-receipt',
  CANNABIS_TYPE_FOR_STATE: 'cannabis-type-for-state',
  SELLABLE_COMMITTED: 'sellable-committed',
  ONLINE_SELLABLE_COMMITTED: 'online-sellable-committed',
  CAN_USE_RETAIL_INSIGHTS: 'can-use-retail-insights',
  CAN_USE_GLOBAL_BROADCASTS: 'global-broadcasts',
  HIDE_BUTTON_VIEW: 'hide-online-store-iframe-code',
  CAN_USE_FEES_MFE: 'mfe-fees-page',
  CAN_USE_TAXES_MFE: 'tax-rates',
  CAN_USE_SYSTEM_ACTIVITY_LOG_MFE: 'event_audit-logs',
  CAN_USE_TAX_ON_SUBTOTAL: 'can_use_tax-on-subtotal',
  CAN_AUTO_ARCHIVE_BATCHES: 'auto-archive_batches',
  PRODUCT_INFO_SOURCING_STRATEGY: 'product-info-sourcing-strategy',
  TAX_TYPE_MAPPING: 'tax-type-mapping',
  MFE_COMPANY_PRICING_TEMPLATES: 'mfe-company-pricing-templates',
  LOYALTY_SERVICE: 'loyalty-service',
  EVENT_LEDGER: 'event_ledger',
  NM_CCD: 'nm-ccd',
  WA_CCRS: 'wa-ccrs',
  CAN_ENABLE_NM_CCD_AND_SYNC: 'can-enable-nm-ccd-and-sync',
  CAN_ENABLE_NM_CCD_DELIVERY: 'can-enable-nm-ccd-delivery',
})



// WEBPACK FOOTER //
// ./src/types/unleashToggles.js